export default __webpack_public_path__ + "static/media/mockup.99ced25d.png";